import { PathOptions } from "leaflet";

export const zoneamento_agroecologico_pernambuco = (
  feature: any
): PathOptions => {
  return {
    fillColor: "#90c878",
    color: "#5a8c3a",
    weight: 1,
    fillOpacity: 0.5,
  };
};
